import axios from 'axios';
import { api, requestConfig } from "../utils/config";

const addChallenge = async (data) => {
  try {

      const res = await axios.post(`${api}/challenge/add`, data, {
          withCredentials: true,
      });

      if(res.data){
        return res.data
      }else{
        return res.response.data;
      }

  } catch (error) {
    console.error("Erro ao registrar:", error);
    throw error;
  }
};

const listChallenge = async () => {
  try {

      const res = await axios.get(`${api}/challenge/`,
        {withCredentials: true},
      );

      if(res.data){
        return res.data
      }else{
        return res.response.data;
      }

      return res;

  } catch (error) {
    console.error("Erro ao registrar:", error);
    throw error;
  }
};

const getChallengeByIdNoAnswer = async (id) => {
  
  try {

    const res = await axios.get(`${api}/challenge/open/${id}`,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

    return res;

  } catch (error) {
    console.log(error);
  }
};

const getChallengeById = async (id) => {
  
  try {

    const res = await axios.get(`${api}/challenge/${id}`,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

    return res;

  } catch (error) {
    console.log(error);
  }
};

const getChallengeByPhaseBlock = async (phase, block) => {
  
  try {

    const res = await axios.post(`${api}/challenge/phase`,
      {
        phase,
        block  
      },
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

    return res;

  } catch (error) {
    console.log(error);
  }
};

const deleteChallengeById = async (id) => {
  
  try {

    const res = await axios.delete(`${api}/challenge/${id}`,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

    return res;

  } catch (error) {
    console.log(error);
  }
};

const updateChallenge = async (data) => {
  try {
    const id = data.get("id");
    const res = await axios.put(`${api}/challenge/` + id, data, 
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

  } catch (error) {
    console.error("Erro ao salvar desafio:", error);
    throw error;
  }
}

const challengeService = {
  addChallenge,
  updateChallenge,
  listChallenge,
  getChallengeById,
  deleteChallengeById,
  getChallengeByPhaseBlock,
  getChallengeByIdNoAnswer
};

export default challengeService;